import {store} from './browserSetup';
// now the react basics
import {createElement} from 'react';
import ReactDOM from 'react-dom';

import bugsnag from '@bugsnag/js';

// Now import the actual application.
import MinimalApp from './components/minimalApp';

// set up BugSnag
if (
  process.env.RELEASE_ENV &&
  process.env.NR_CLIENT_BUGSNAG_API &&
  process.env.USE_BUGSNAG === 'true'
) {
  global.bugsnag = bugsnag({
    apiKey: process.env.NR_CLIENT_BUGSNAG_API,
    releaseStage: process.env.RELEASE_ENV,
  });
}

// Now, all that done, we can add the App to the DOM.
// The App is wrapped by a non-client-React controlled layout so it's injected
// to the specific tag ID where it's supposed to live.
ReactDOM.render(createElement(MinimalApp, {store}), document.getElementById('app'));
